import React from 'react'
import { Checkbox, Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material'

import { IOnboardingMenuStep } from '../../Onboarding'
import { LineArrow, StyledButton } from 'shared'

const useStyles = makeStyles(() => ({
  checkbox: {
    padding: 0,
    cursor: 'default',
  },
}))

interface OnboardingMenuStepProps extends IOnboardingMenuStep {
  isActive: boolean
  onStepClick: () => void
}

const OnboardingMenuStep = ({
  text,
  checked,
  buttonText,
  onClick,
  onStepClick,
  isActive,
}: OnboardingMenuStepProps) => {
  const classes = useStyles()
  return (
    <Grid
      container
      flexWrap="nowrap"
      gap={2}
      alignItems={isActive ? 'flex-start' : 'center'}
    >
      <Grid>
        <Checkbox
          icon={<RadioButtonUnchecked />}
          checkedIcon={<CheckCircle />}
          color="secondary"
          size="large"
          checked={checked}
          disabled={!checked}
          className={classes.checkbox}
        />
      </Grid>
      <Grid container flexDirection="column" gap={1}>
        <Typography>{text}</Typography>
        {isActive ? (
          <Grid>
            <StyledButton
              color="mint"
              variant="contained"
              onClick={() => {
                onClick()
                onStepClick()
              }}
              endIcon={<LineArrow />}
              fullWidth
            >
              {buttonText}
            </StyledButton>
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  )
}

export default OnboardingMenuStep
